import React, {useEffect, useState} from "react";
import type { ContextProps } from '../../types';
import {PageTitle} from "../../Components/Landmarks";
import {LibraryPublisherView} from "./LibraryPublisherView";
import {locations} from "../../Utilities/Location";
import {libraryCatalogApi} from "./libraryCatalogApi";
import {emptyPublisherModel} from "./libraryFactory";
import {SelectField} from "../../Components/Inputs";
import {createListFromArrayOfObjects} from "../../Utilities/Types/listUtilities";
import {emptyGuid} from "../../Utilities/commonUtilities";


export const LibraryPublisherContainer = ({
                                              handleApiCall,
                                              libraryPublisherId,
                                              redirect,
                                              systemType,
                                          }: ContextProps) => {
    const [publisher, setPublisher] = useState<Record<string, unknown>>();
    const [publishers, setPublishers] = useState<Record<string, unknown>[]>();
    const publisherList = createListFromArrayOfObjects(publishers, "publisherId", "name");

    const handleChangePublisher = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const path = locations.LIBRARY_PUBLISHER.getLink(event.target.value).to;
        redirect(path);
    }

    const handleReturn = () => redirect(locations.LIBRARY_CATALOG.getLink(systemType).to);

    const handleSavePublisher = async (publisher: Record<string, unknown>) => {
        return handleApiCall(() => libraryCatalogApi.savePublisher(publisher),
            handleReturn);
    };

    useEffect(() => {
        const getPublishers = () => {
            handleApiCall(() => libraryCatalogApi.getPublishers(), (results: Record<string, unknown>[]) => setPublishers(results));
        }

        const getPublisher = () => {
            const publisher = publishers?.find((v: Record<string, unknown>) => v.publisherId === libraryPublisherId) || emptyPublisherModel;
            setPublisher(publisher);
        }

        if (!publishers)
            getPublishers();
        else if (libraryPublisherId)
            getPublisher();

    }, [publishers, libraryPublisherId]);

    if (!publisher) return <></>;

    return <>
        <PageTitle h1={`Manage Publishers`}/>
        <SelectField
            defaultOption={"-- Create New Publisher --"}
            defaultOptionValue={emptyGuid}
            label={"Select Publisher to Manage"}
            name={'PublisherList'}
            onChange={handleChangePublisher}
            options={publisherList}
            value={libraryPublisherId}
        />
        <LibraryPublisherView
            handleSavePublisher={handleSavePublisher}
            handleReturn={handleReturn}
            publisher={publisher}
        />
    </>;
};
